import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './pages/landing/landing.component';
import { HomeComponent } from './pages/home/home.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { ContactComponent } from './pages/contact/contact.component';
import { SignoutComponent } from './pages/signout/signout.component';
import { AuthorizationComponent } from './pages/authorization/authorization.component';
import { CheckoutSuccessComponent } from './pages/checkout-success/checkout-success.component';
import {
  NoAuthGuardService as NoAuthGuard,
  AuthGuardService as AuthGuard,
  LandingRedirectGuard,
} from './services/auth-guard.service';

const routes: Routes = [
  {
    path: 'courses',
    loadChildren: () =>
      import('./features/courses/courses.module').then((m) => m.CoursesModule),
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./features/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'signin',
    component: SignInComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'signout',
    component: SignoutComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'signup',
    component: SignUpComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'pricing',
    component: PricingComponent,
  },
  {
    path: 'contact',
    component: ContactComponent,
  },
  {
    path: 'subscription',
    redirectTo: 'account/subscription',
    pathMatch: 'full',
  },
  {
    path: 'checkout',
    redirectTo: 'account/checkout',
    pathMatch: 'full',
  },
  {
    path: 'checkout-success',
    component: CheckoutSuccessComponent,
  },
  {
    path: 'authorization',
    component: AuthorizationComponent,
  },
  {
    path: 'home',
    redirectTo: 'courses/home',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LandingComponent,
    canActivate: [LandingRedirectGuard],
    pathMatch: 'full',
  },
  {
    path: '**',
    component: LandingComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
